import api from "src/api/index";

export async function getPointCategories() {
  try {
    const response = await api.get("point-categories")
    return response.data.items
  } catch (error) {
    console.error("ошибка загрузки типов точек", error?.message)
    return []
  }
}
